import React, { useEffect, useRef, useState } from "react";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { Button, Input, InputRef, Select, Space, Spin, Table } from "antd";
import { useApplicationContext } from "../../application/ApplicationContext";
import { getEvent } from "../../services/EventService";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import { Agenda } from "../../models/Agenda";
import { Option } from "antd/es/mentions";
import { getAllParticipantInAgenda } from "../../services/AgendaService";
import type { ColumnsType, ColumnType } from "antd/es/table";
import { Participant } from "../../models/Participant";
import Highlighter from "react-highlight-words";
import { FilterConfirmProps } from "antd/es/table/interface";
import { ClockCircleOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";

function HostScreen() {
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [allAgendas, setAllAgendas] = useState([]);
  const [allParticipant, setAllPArticipant] = useState([]);
  let { id } = useParams();
  const { setBreadcrumb } = useApplicationContext();
  const searchInput = useRef<InputRef>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [paginationNumber, setPaginationNumber] = useState<any>(30);
  const [searchText, setSearchText] = useState<string>("");
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [filteredParticipantList, setFilteredParticipantList] = useState<
    Participant[]
  >([]);
  const navigate = useNavigate();

  useEffect(() => {
    getEvent(id as string).then((res: AxiosResponse) => {
      let data = res?.data?.result;

      console.log("data", data.agendas);
      let arr = ["Host događaja"];
      arr.push(data.name);
      setBreadcrumb(arr);
      // let filter = data?.agendas?.filter(
      //   (agenda: Agenda) => agenda.instructorName !== null
      // );

      let filter = data?.agendas?.sort((a: any, b: any) => {
        const dateComparison = a.date.localeCompare(b.date);

        if (dateComparison === 0) {
          const startTimeA = a.time[0];
          const startTimeB = b.time[0];
          return startTimeA.localeCompare(startTimeB);
        }

        return dateComparison;
      });
      console.log("filter", filter);
      setAllAgendas(filter);
    });
  }, []);

  const handleSelectAgenda = (id: string) => {
    setActiveSpinner(true);
    getAllParticipantInAgenda(id).then((res: AxiosResponse) => {
      let data = res.data.result;
      console.log("Data", data);
      let participants = data?.map((participant: Participant) => {
        return {
          ...participant,
          companyName:
            participant?.registration?.registrationCompanyName ?? "/",
        };
      });
      setAllPArticipant(participants);
      setActiveSpinner(false);
    });
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  type DataIndex = keyof Participant;
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<Participant> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Pretraži`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleSearch(selectedKeys as string[], confirm, dataIndex);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, border: "none" }}
          >
            Pretraži
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              close();
              setSearchedColumn("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Poništi
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#C7363D" : undefined }} />
    ),
    onFilter: (value, record) =>
      (record[dataIndex] ?? "")
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
            color: "#0D4077",
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<Participant | any> = [
    {
      title: "Red. broj",
      width: 100,
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName, text, index) => {
        return (
          <span className="blue-text">
            {(pageNumber - 1) * paginationNumber + index + 1}
          </span>
        );
      },
    },
    {
      title: "Ime",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => (a.firstName < b.firstName ? -1 : 1),
      //defaultSortOrder: "ascend",
      render: (firstName, record) => {
        return <span className="blue-text name-container">{firstName}</span>;
      },
      ...getColumnSearchProps("firstName"),
    },
    {
      title: "Prezime",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => (a.lastName < b.lastName ? -1 : 1),
      render: (lastName) => <span className="blue-text">{lastName}</span>,
      ...getColumnSearchProps("lastName"),
    },
    {
      title: "Pravno lice",
      dataIndex: "companyName",
      key: "companyName",
      sorter: (a, b) =>
        (a?.companyName ?? "") < (b?.companyName ?? "") ? -1 : 1,
      render: (companyName) => (
        <span className="blue-text">{companyName ?? "/"}</span>
      ),
      ...getColumnSearchProps("companyName"),
    },
    {
      title: "Telefon",
      dataIndex: "phone",
      key: "phone",
      render: (phone) => <span className="blue-text">{phone}</span>,
      ...getColumnSearchProps("phone"),
    },
    {
      title: "Opcije",
      fixed: "right",
      width: 240,
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <span
            className="action-button"
            onClick={() => handleViewButton(record.id as string)}
          >
            Pregled
          </span>
        </Space>
      ),
    },
  ];

  const handleViewButton = (id: string) => {
    return navigate(`/participant-overview/${id}`, { state: 4 });
  };

  const titleAgendaFunc = (title: string) => {
    var naslov = title.trim(); // Uklanja prazne karaktere sa početka i kraja stringa

    if (naslov.length > 150) {
      var skraceniNaslov = naslov.substring(0, 150) + "...";
    } else {
      var skraceniNaslov = naslov;
    }

    return skraceniNaslov;
  };

  return (
    <PageLayout>
      <Spin spinning={activeSpinner}>
        <div className="host-screen">
          <div className="agenda-header">
            <label className="label-c">Agenda:</label>
            <Select
              //  onClick={handleOnClickRoomType}
              onChange={handleSelectAgenda}
              placeholder="Izaberite agendu"
            >
              {allAgendas.map((agenda: Agenda, i: number) => (
                <Option key={agenda.id} value={agenda.id}>
                  {" "}
                  {i + 1}. {moment(agenda?.time[0]).format("HH:mm")}-
                  {moment(agenda?.time[1]).format("HH:mm")};{" "}
                  {moment(agenda?.date).format("DD-MM-YYYY")}
                  <ClockCircleOutlined
                    style={{
                      marginLeft: "10px",
                      color: "#55ad5b",
                      display: "inline",
                    }}
                  />{" "}
                  {" -> "} {titleAgendaFunc(agenda.title)}
                </Option>
              ))}
            </Select>
          </div>
          <div className="table-h-s">
            <Table
              sticky={true}
              //   scroll={{ x: 1500 }}
              columns={columns}
              rowKey={(data) => {
                return data.id;
              }}
              pagination={{
                onChange(current) {
                  setPageNumber(current);
                },
                defaultPageSize: 30,
                showSizeChanger: true,
                pageSizeOptions: ["30", "50", "100"],
              }}
              dataSource={allParticipant}
              onChange={(pagination, filters, sorter, extra) => {
                setPaginationNumber(pagination.pageSize);
                setFilteredParticipantList(extra.currentDataSource);
              }}
              className="table-container"
            />
          </div>
        </div>
      </Spin>
    </PageLayout>
  );
}

export default HostScreen;
